<ion-content forceOverscroll="false">
    <app-header [fixedTitle]="true">
        <app-toolbar [title]="title">
            <app-toolbar-button [text]="'lbl_cancel' | translate" slot="start" (click)="closeModal()"></app-toolbar-button>
            <app-toolbar-button [text]="'lbl_save' | translate" slot="end" (click)="saveComments()"></app-toolbar-button>
        </app-toolbar>
    </app-header>

    <main hasFooter>
        <app-textarea [(ngModel)]="comments" rows="10"></app-textarea>
    </main>
</ion-content>
